module.exports = __webpack_public_path__ + "static/media/tada.89f15555.mp3";